export default __webpack_public_path__ + "42739083a48a7aebef7671a2b8fd7e10.png";